
import { Code, Search, Settings, Image as ImageIcon } from "lucide-react";
import { useTranslatedText } from "@/hooks/useTranslate";

const WebDevSection = () => {
  const titleText = useTranslatedText("Desarrollo web");
  const subtitleText = useTranslatedText("Creamos, construimos, optimizamos y apoyamos tu sitio web, en Tecnosync cada paso está cuidadosamente diseñado para brindarte una presencia en línea efectiva y duradera.");

  const feature1Title = useTranslatedText("Diseño UX/UI");
  const feature1Desc = useTranslatedText("Creamos experiencias web que cautivan a tu audiencia, mejoran la usabilidad y aumentan la retención.");
  const feature2Title = useTranslatedText("Desarrollo");
  const feature2Desc = useTranslatedText("Nos aseguramos que cada sitio sea intuitivo y con un rendimiento impecable en todos los dispositivos.");
  const feature3Title = useTranslatedText("SEO");
  const feature3Desc = useTranslatedText("Desarrollamos estrategias efectivas para atraer tráfico, retener visitantes y convertirlos en clientes.");
  const feature4Title = useTranslatedText("Soporte");
  const feature4Desc = useTranslatedText("Asistencia continua para solucionar problemas, actualizar y garantizar que tu sitio esté siempre disponible.");

  const steps = [
    { icon: <ImageIcon className="w-6 h-6" />, number: "01", title: feature1Title, description: feature1Desc },
    { icon: <Code className="w-6 h-6" />, number: "02", title: feature2Title, description: feature2Desc },
    { icon: <Search className="w-6 h-6" />, number: "03", title: feature3Title, description: feature3Desc },
    { icon: <Settings className="w-6 h-6" />, number: "04", title: feature4Title, description: feature4Desc },
  ];

  return (
    <section className="py-20 bg-techno-dark relative">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-techno-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-5xl font-bold text-techno-purple mb-6">{titleText}</h2>
          <p className="text-gray-300 text-lg leading-relaxed">{subtitleText}</p>
        </div>

        {/* Timeline */}
        <div className="grid md:grid-cols-4 gap-6 max-w-6xl mx-auto relative">
          {/* Connecting line (desktop) */}
          <div className="hidden md:block absolute top-[3.5rem] left-[12%] right-[12%] h-px bg-gradient-to-r from-techno-purple/40 via-techno-accent/40 to-techno-purple/40"></div>

          {steps.map((step, index) => (
            <div
              key={index}
              className="text-center space-y-4 animate-fade-in relative"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Numbered circle */}
              <div className="mx-auto w-16 h-16 rounded-full glass-strong flex items-center justify-center relative z-10 group hover:scale-110 transition-transform duration-300">
                <span className="text-purple-300 font-bold text-lg">{step.number}</span>
              </div>

              <div className="text-techno-purple mx-auto">{step.icon}</div>

              <h3 className="text-white font-semibold text-lg">{step.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-techno-purple/40 to-transparent"></div>
    </section>
  );
};

export default WebDevSection;
